













import { defineComponent, computed } from '@vue/composition-api';

const CommonPaymentTypeSelector = defineComponent({
  setup(props: any) {
    const _value = computed(() => props.value);

    return {
      _value,
    };
  },
  props: {
    level: {},
    label: {
      type: String,
      default() { return 'ประเภทค่าใช้จ่าย'; },
    },
    value: {
      type: String,
      default() { return ''; },
    },
    showLabel: { default: true },
    rules: { default: '' },
  },
});

export default CommonPaymentTypeSelector;
